import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  type DrawerProps,
  Flex,
  IconButton,
  Text,
} from '@chakra-ui/react';

import { XFilledIcon } from '../../icons';

interface CustomDrawerV2Props extends Omit<
  DrawerProps,
  'isOpen' | 'onClose' | 'children'
> {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
  onClose?: () => void;
  dismissible?: boolean;
}

export default function CustomDrawerV2({
  open,
  setOpen,
  title,
  children,
  onClose,
  dismissible = false,
  placement = 'bottom',
  ...rest
}: CustomDrawerV2Props) {
  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <Drawer
      isOpen={open}
      onClose={handleClose}
      placement={placement}
      closeOnOverlayClick={dismissible}
      closeOnEsc={dismissible}
      {...rest}
    >
      <DrawerOverlay />
      <DrawerContent minH="90vh" borderTopRadius="24px" pb={6}>
        <Flex
          borderBottom="1px solid"
          borderColor="#F5F6F6"
          px={4}
          py={4}
          justifyContent="space-between"
          alignItems="center"
          mb={8}
        >
          <Text
            fontSize=".75rem"
            color="#667076"
            fontWeight="medium"
            textTransform="uppercase"
            letterSpacing="0.12rem"
          >
            {title}
          </Text>
          <IconButton
            aria-label="Close drawer"
            icon={<XFilledIcon />}
            variant="ghost"
            size="sm"
            onClick={handleClose}
            _hover={{ background: 'transparent' }}
          />
        </Flex>

        <DrawerBody px={{ base: 4, md: 6 }} overflowY="auto">
          {children}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
